import React, { useEffect, useRef, useState } from 'react';
import OhMyFoodLogo from '../../../assets/svg/OhMyFoodLogo';
import OhMyFoodText from '../../../assets/svg/OhMyFoodText';
import './MenuHeader.css';
import bannerImg from '../../../assets/vendortopbackground.png';
import { useNavigate } from 'react-router-dom';
import starPic from '../../../assets/StarWhite.svg';
import locationIcon from '../../../assets/locationImg.svg';
import { useTranslation } from 'react-i18next';
import SearchIconSvg from '../../../assets/svg/searchIcon';

const MenuHeader = ({ restaurantData, searchQuery, setSearchQuery }) => {
    const overlayRef = useRef(null);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
    const rawRating = restaurantData?.vendor?.menuItem_averageRating;

    const averageRating =
        rawRating && rawRating !== 'No ratings yet' && !isNaN(Number(rawRating))
            ? Number(rawRating).toFixed(1)
            : '0.0';

    const address = restaurantData?.vendor?.Address
        ? `${restaurantData?.vendor?.Address.trim().replace(/,+\s*$/, '')}, ${restaurantData?.vendor?.city}, ${restaurantData?.vendor?.state}, ${restaurantData?.vendor?.country} - ${restaurantData?.vendor?.pincode}`
        : '';
        
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (overlayRef.current && !overlayRef.current.contains(event.target)) {
                setSearchQuery('');
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setSearchQuery]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 601);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNavigate = () => {
        navigate('/dashboard');
    };

    return (
        <div className='menu-header'>
            <div
                className='restaurant-top-menubar-container'
                style={{
                    backgroundImage: `url(${
                        restaurantData?.vendor?.Banner_Image || bannerImg
                    })`,
                }}
            >
                <div className='restaurant-banner-overlay'></div>
                {isMobile ? (
                    <div className='restaurant-header-info-mobile'>
                        <div className="logo-rating-mobile">
                            <div className='omf-container1' onClick={() => handleNavigate()}>
                                <OhMyFoodLogo width={31} height={36}/>
                                <OhMyFoodText width={69.43} height={18} className='oh-my-food-text'/>
                            </div>
                            <div className='res-star-rating'>
                                <div className='img-rating-restaurant'>
                                    <p className='rating-order'>
                                        {averageRating}
                                    </p>
                                    <img className='star-img-order' src={starPic} alt='star' />
                                </div>
                                <div className='customer-count-rating'>
                                    <p className='rating-count-restaurant1'>
                                        {restaurantData?.vendor?.menuItem_reviewUserCount || 0}
                                    </p>
                                    <p className='rating-text1'>
                                        {t('restaurantpage.ratings-text')}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='restaurant-turn-on-location-container-mobile'>
                            <div className='restaurant-turn-on-location-description'>
                                <p className='restaurant-name1'>
                                    {restaurantData?.vendor?.Name}
                                </p>
                            </div>
                            <div className='restaurant-address-container'>
                                <img
                                    src={locationIcon}
                                    alt='location'
                                    className='location-icon-restaurant'
                                />
                                <p className='resturant-address1'>
                                    {address}
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='restaurant-header-info'>
                        <div className='omf-container1' onClick={() => handleNavigate()}>
                            <OhMyFoodLogo />
                            <OhMyFoodText className='oh-my-food-text'/>
                        </div>
                        <div className='restaurant-turn-on-location-container'>
                            <div className='restaurant-turn-on-location-description'>
                                <p className='restaurant-name1'>
                                    {restaurantData?.vendor?.Name}
                                </p>
                                <div className='res-star-rating'>
                                    <div className='img-rating-restaurant'>
                                        <p className='rating-order'>
                                            {averageRating}
                                        </p>
                                        <img 
                                            className='star-img-order'
                                            src={starPic} alt='star'
                                            style={{marginBottom: '4px'}}
                                        />
                                    </div>
                                    <div className='customer-count-rating'>
                                        <p className='rating-count-restaurant1'>
                                            {restaurantData?.vendor?.menuItem_reviewUserCount || 0}
                                        </p>
                                        <p className='rating-text1'>
                                            {t('restaurantpage.ratings-text')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='restaurant-address-container'>
                            <img
                                src={locationIcon}
                                alt='location'
                                className='location-icon-restaurant'
                            />
                            <p className='resturant-address1'>
                                {address}
                            </p>
                        </div>
                    </div>
                )}

                <div className='search-container1'>
                    <div className='restaurant-search-container'>
                        <SearchIconSvg
                            className='restaurant-search-icon'
                            color={'#464B59'}
                            height='20'
                            width='20'
                        />

                        <input
                            type='text'
                            className='restaurant-input-field'
                            value={searchQuery}
                            placeholder='Search menu...'
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuHeader;
